export const MIN_ZOOM = 0.2
export const MAX_ZOOM = 3
export const ZOOM_STEP = 1.25

export const CARD_WIDTH = 240
export const CARD_ESTIMATED_HEIGHT = 340

/** Approximate hit boxes for marquee selection (world space). */
export const FILE_BOUNDS_WIDTH = 280
export const FILE_BOUNDS_HEIGHT = 220
export const LINK_BOUNDS_WIDTH = 288
export const LINK_BOUNDS_HEIGHT = 140
export const STAMP_BOUNDS_SIZE = 48

export const GRID_COLS = 3
export const GRID_GAP_X = 64
export const GRID_GAP_Y = 96

export const FIT_PADDING = 96

/** Pixels of pointer travel before a press counts as a drag instead of a click. */
export const DRAG_THRESHOLD = 4

export const DOT_GRID_SIZE = 24

export const STROKE_COLOR = '#2563eb'
export const STROKE_WIDTH = 3

/** Files above this size are skipped (upload and demo preview). */
export const MAX_IMAGE_PREVIEW_BYTES = 8 * 1024 * 1024

export const CANVAS_FILES_BUCKET = 'order-message-attachments'
export const CANVAS_PERSIST_MS = 400

export const STAMP_EMOJIS = ['👍', '❤️', '🔥', '⭐', '❓', '👎', '🎉', '💯']
export const DEFAULT_STAMP = STAMP_EMOJIS[0]

/** Keeps stamps above product cards (whose z-index grows with bring-to-front). */
export const STAMP_Z_INDEX = 10000

/** Keeps drawings above product cards, same as stamps. */
export const STROKE_Z_INDEX = 10000
